import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import * as RequestState from '../../requestStates/RequestState';
export default function LoadingWrapper({
  children,
  ErrorComponent,
  errorMessage,
  LoadingComponent,
  showOverlay,
  requestStatus,
  showLoadingOnUninitialized = true
}) {
  // convert to a string array if it's a single string
  const statuses = Array.isArray(requestStatus) ? requestStatus : [requestStatus];

  const isEveryStatus = status => statuses.every(s => s === status);

  const isSomeStatus = status => statuses.some(s => s === status);

  const showLoading = isSomeStatus(RequestState.PENDING) || isEveryStatus(RequestState.UNINITIALIZED) && showLoadingOnUninitialized;

  if (showLoading) {
    if (LoadingComponent) return /*#__PURE__*/_jsx(LoadingComponent, {});

    if (showOverlay) {
      return /*#__PURE__*/_jsxs("div", {
        style: {
          position: 'relative'
        },
        children: [/*#__PURE__*/_jsx(UILoadingOverlay, {
          contextual: true
        }), children]
      });
    }

    return /*#__PURE__*/_jsx(UILoadingSpinner, {});
  }

  if (isEveryStatus(RequestState.SUCCEEDED)) return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });

  if (isSomeStatus(RequestState.FAILED)) {
    if (ErrorComponent) return /*#__PURE__*/_jsx(ErrorComponent, {});
    return /*#__PURE__*/_jsx(UIAlert, {
      type: "danger",
      children: errorMessage || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-common.loadingWrapperDefaultError"
      })
    });
  }

  return null;
}